export enum DockAppointmentProvider {
  CONDUIT = 'CONDUIT',
}
